// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import t from '../types';

/**
 * Retrieve customers transactions report.
 */
export function useSOATransactionsReport(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.STATEMENT_OF_ACCOUNTS, query],
    {
      method: 'get',
      url: '/financial_statements/statement-of-accounts',
      params: query,
      headers: {
        Accept: 'application/json+table',
      },
    },
    {
      select: (res) => ({
        data: res.data.table,
        tableRows: res.data.table.rows,
      }),
      defaultData: {
        tableRows: [],
        data: [],
      },
      ...props,
    },
  );
}

export const useSOATransactionsXlsxExport = (query, args) => {
  const url = '/financial_statements/statement-of-accounts';
  const config = {
    headers: {
      accept: 'application/xlsx',
    },
    params: query,
  };
  const filename = 'soa_transactions.xlsx';

  return useDownloadFile({
    url,
    config,
    filename,
    ...args,
  });
};

export const useSOATransactionsCsvExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/statement-of-accounts',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'soa_transactions.csv',
    ...args,
  });
};

/**
 * Retrieves the pdf content of customers transactions.
 */
export const useSOATransactionsPdfExport = (query = {}) => {
  return useRequestPdf({
    url: '/financial_statements/statement-of-accounts',
    params: query,
  });
};
